import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {Facility} from "types/Facility";

// Types ----

type FacilityContextMenuProps = {
  facility: Facility
  onDeleteFacility: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function FacilityContextMenu({
  facility,
  onDeleteFacility,
  viewDisabled,
  editDisabled,
  deleteDisabled,
  position = 'right'
}: FacilityContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewFacility() {
    void navigate(`/facilities/${facility.id}`)
  }

  function editFacility() {
    void navigate(`/facilities/${facility.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('facilities:read') &&
        <DropdownItem
          name="View"
          icon={EyeIcon}
          onClick={viewFacility}
          disabled={!!viewDisabled}
        />
      }

      {auth.can('facilities:write') &&
        <DropdownItem
          name="Edit"
          icon={PencilIcon}
          onClick={editFacility}
          disabled={!!editDisabled}
        />
      }

      {auth.can('facilities:write') &&
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDeleteFacility}
          disabled={!!deleteDisabled}
        />
      }
    </Dropdown>
  );
}

export default FacilityContextMenu;